import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Sub Branch Channel Opps',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  subDashChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  subDashCompareChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const subBranchDashOppsByChannelSlice = createSlice({
  name: 'subBranchDashOppsByChannel',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setSubDashChannelOppsRange: (state, action) => ({
      ...state,
      subDashChannelOppsRange: action.payload,
    }),
    setSubDashCompareChannelOppsRange: (state, action) => ({
      ...state,
      subDashCompareChannelOppsRange: action.payload,
    }),
  },
});

export const subBranchDashOppsByChannelActions = subBranchDashOppsByChannelSlice.actions;

export default subBranchDashOppsByChannelSlice.reducer;
